export const isMobile = () => {
    return screen.width <= 599
}

export const isTablet = () => {
    return screen.width <= 768
}